module.exports = __webpack_public_path__ + "static/media/River3.24c3c3b5.jpeg";